import React from "react";

import { ReactComponent as WarningIcon } from "static/images/warning-alert.svg";
import styles from "./uploadLogoAgentOffice.module.scss";

const WarningUploadLogo = () => {
	return (
		<>
			<div className={styles.warning}>
				<div>
					<WarningIcon width="16" />
				</div>
				<p>
					This logo will also be placed in the Merchant Application &
					Agreement document <br />
					on a white background. The light elements of the uploaded
					logo may not be visible.
				</p>
			</div>
		</>
	);
};

export { WarningUploadLogo };
